(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('karcherCustomTranslation', karcherCustomTranslation);

    /** @ngInject */
    function karcherCustomTranslation($translate) {
        return function(text) {
          if(!text) return;
          switch (text) {
            case "Hei%C3%9Fwachs":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_1");
            case "Heißwachs":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_1");
            case "Hochdruckw%C3%A4sche":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_2");
            case "Hochdruckwäsche":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_2");
            case "Powerfelgenschaum":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_3");
            case "Powerschaum":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_4");
            case "STOP":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_5");
            case "Schaumw%C3%A4sche%20HD":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_6");
            case "Schaumwäsche HD":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_6");
            case "Sp%C3%BClen":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_7");
            case "Spülen":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_7");
            case "Top-Pflege":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_8");
            case "unit%20open":
              return $translate.instant("AVAILABILITY_STATUS_1");
            case "unit%20closed%20(holiday)":
              return $translate.instant("AVAILABILITY_STATUS_2");
            case "unit%20closed%20(operating time)":
              return $translate.instant("AVAILABILITY_STATUS_3");
            case "unit%20closed%20(fault)":
              return $translate.instant("AVAILABILITY_STATUS_4");
            case "unit%20closed%20(other)":
              return $translate.instant("AVAILABILITY_STATUS_5");
            case "vacuums%20not%20installed":
              return $translate.instant("AVAILABILITY_VACUUMS_STATUS_1");
            case "vacuums%20open":
              return $translate.instant("AVAILABILITY_VACUUMS_STATUS_2");
            case "vacuums%20closed%20(holiday)":
              return $translate.instant("AVAILABILITY_VACUUMS_STATUS_3");
            case "vacuums%20closed%20(operating time)":
              return $translate.instant("AVAILABILITY_VACUUMS_STATUS_4");
            case "vacuums%20closed%20(fault)":
              return $translate.instant("AVAILABILITY_VACUUMS_STATUS_5");
            case "vacuums%20closed%20(other)":
              return $translate.instant("AVAILABILITY_VACUUMS_STATUS_6");
            default:
              return text;
          }
        };
    }
})();
